var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterreact = function SvgTwitterreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 30 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24.001 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-logo-twitter",
    d: "M24.002 4.561a9.967 9.967 0 0 1-2.828.777 4.935 4.935 0 0 0 2.167-2.722 9.793 9.793 0 0 1-3.128 1.193 4.924 4.924 0 0 0-8.519 3.362 4.807 4.807 0 0 0 .127 1.122A13.962 13.962 0 0 1 1.669 3.15a4.922 4.922 0 0 0 1.53 6.57 4.815 4.815 0 0 1-2.238-.614v.061a4.923 4.923 0 0 0 3.952 4.824 4.964 4.964 0 0 1-1.3.173 4.652 4.652 0 0 1-.926-.091 4.931 4.931 0 0 0 4.6 3.418 9.882 9.882 0 0 1-6.119 2.108 10 10 0 0 1-1.175-.071 13.779 13.779 0 0 0 7.545 2.222A13.916 13.916 0 0 0 21.56 7.745c0-.213-.005-.427-.015-.635a10.015 10.015 0 0 0 2.457-2.549Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgTwitterreact;